import { makeAutoObservable } from 'mobx';

class HeaderViewModel {
  sortable;
  column;
  sort = '';

  constructor(column, sortable) {
    makeAutoObservable(this);

    this.column = column;
    this.sortable = sortable;
  }

  get sortingAllowed() {
    return this.column.sortable !== false && this.sortable && this.sortBy;
  }

  get sortBy() {
    return this.column.sortBy || this.column.attribute;
  }
}

export default HeaderViewModel;
